import React, { useState, useEffect } from 'react';
import { Trans } from 'react-i18next';
import { useLazyQuery, useMutation } from "@apollo/client";
import moment from "moment";

import { reverseReceiveTime, validateInputDates } from '../../../../Helpers/ReceiveTimeInArray';
import { UPDATE_BOOKING } from '../../../../GraphQL/Mutations/bookings';
import { GET_BOOKING_BY_SOURCE_ID } from '../../../../GraphQL/Queries/bookings';

export const ReleaseCheckInVehicleButton = ({ calendarBooking, legacyApiReleaseVehicle, legacyApiReturnVehicle, isRelease, confirms, closeModal, sourceBookingId }) => {
    const [gqlBooking, setGqlBooking] = useState(null);

    // const [updateBookingMutation, { data, loading, error }] = useMutation(UPDATE_BOOKING);

    const [getBookingQuery, { loading: loadingBooking }] = useLazyQuery(GET_BOOKING_BY_SOURCE_ID, {
        errorPolicy: 'all',
        fetchPolicy: 'network-only',
    });

    useEffect(() => {
        if (calendarBooking?.extendedProps) {
            const { booking, resourceId: vehicleId } = calendarBooking?.extendedProps;
            setGqlBooking({ ...booking, vehicleId });
        } else {
            getBookingQuery({ variables: { sourceBookingId: +sourceBookingId } })
                .then((bookingResponse) => {
                    const booking = bookingResponse?.data.getBookingBySourceBookingId;
                    setGqlBooking(booking)
                })
                .catch((error) => {
                    console.error('[getBookingBySourceBookingIdQuery] error: ', error);
                });
        }
    }, [calendarBooking]);

    const parseSnapshot = (form, type) => {
        const { fuel, damage, odometer, damage_notes } = form;

        return {
            type,
            fuelLevel: fuel,
            isDamaged: Boolean(damage),
            odometer: parseInt(odometer),
            damagedNotes: damage_notes
        }
    }

    const getIsoFromDateTime = (date, time) => moment(`${date} ${reverseReceiveTime(time)}`).format('YYYY-MM-DDTHH:mm:ssZ');

    // [not in use due to queue data sync implementation]
    const releaseVehicleGraphQL = (releaseForm) => {
        // const vehicleConditionalSnapshots = parseSnapshot(releaseForm, 'released');

        // const updateBookingInput = {
        //     id: +gqlBooking.id,
        //     releasedBy: releaseForm.name,
        //     actualReleasedAt: getIsoFromDateTime(releaseForm.date, releaseForm.time),
        //     status: 'released',
        //     vehicleConditionalSnapshots
        // }

        // // TODO: remove this workaround when we remove the legacy API (we'll have the correct time string)
        // const parsedBookingInput = validateInputDates(updateBookingInput, { actualReleasedAt: moment().format('YYYY-MM-DDTHH:mm:ssZ') });

        // updateBookingMutation({ variables: { input: parsedBookingInput } }).then((response) => {
        //     showStatusMsg('Vehicle released successfully.', 'success');
        //     closeModal();
        // }).catch((error) => {
        //     console.error('[updateBookingMutation] error: ', error);
        // });
    }

    // [not in use due to queue data sync implementation]
    const returnVehicleGraphQL = (returnForm) => {
        // const vehicleConditionalSnapshots = parseSnapshot(returnForm, 'returned');

        // const updateBookingInput = {
        //     id: +gqlBooking.id,
        //     returnedBy: returnForm.name,
        //     actualReturnedAt: getIsoFromDateTime(returnForm.date, returnForm.time),
        //     status: 'completed',
        //     vehicleConditionalSnapshots
        // }

        // // TODO: remove this workaround when we remove the legacy API (we'll have the correct time string)
        // const parsedBookingInput = validateInputDates(updateBookingInput, { actualReturnedAt: moment().format('YYYY-MM-DDTHH:mm:ssZ') });

        // updateBookingMutation({ variables: { input: parsedBookingInput } }).then((response) => {
        //     showStatusMsg('Vehicle returned successfully.', 'success');
        //     closeModal();
        // }).catch((error) => {
        //     console.error('[updateBookingMutation] error: ', error);
        // });
    }

    const releaseVehicle = () => legacyApiReleaseVehicle(releaseVehicleGraphQL);
    const returnVehicle = () => legacyApiReturnVehicle(returnVehicleGraphQL);

    const isButtonDisabled = !(confirms.booking_confirm && confirms.vehicle_confirm && confirms.damage_confirm);

    return (
        <a
            className={`button primary float-right px-32${isButtonDisabled ? ' disabled' : ''}`}
            onClick={isRelease ? releaseVehicle : returnVehicle}
        >
            {/* <span style={{verticalAlign: "text-top"}}>{releaseVehicleIcon}</span> */}
            <Trans>{isRelease ? 'Release' : 'Check In'} Vehicle</Trans>
        </a>
    )
}
